/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 13:10:11
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  payments: {
    list: [],
    count: 0,
  },
  invoices: {
    list: [],
    count: 0,
  },
  correctionInvoices: {
    list: [],
    count: 0,
  },
  paymentsError: null,
};

const getters = {
  customerPayments: state => state.payments,
  customerInvoices: state => state.invoices,
  customerCorrectionInvoices: state => state.correctionInvoices,
  lastInvoice: state => state.invoices.list[0],
  paymentsError: state => state.paymentsError,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/PaymentsAndInvoices/index.js